import { render } from "./TasksFinishedListView.vue?vue&type=template&id=69728f54"
import script from "./TasksFinishedListView.vue?vue&type=script&lang=js"
export * from "./TasksFinishedListView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__